/*
 * @Author: Teemo Ding
 * @Date: 2022-01-06 10:14:48
 * @LastEditTime: 2022-01-07 09:31:03
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/SubscriptionBuy/SubscriptionBuyEdit/config.ts
 */
import { SubscriptionOrderStatus } from '@/src/types/common/order';

export const statusText = ({ getI18n }) => ({
  [SubscriptionOrderStatus.Active]: getI18n(
    'subscriptionBuy.subscriptionBuy.subscriptionBuyEdit_config_Active',
  ),
  [SubscriptionOrderStatus.Cancelled]: getI18n(
    'subscriptionBuy.subscriptionBuy.subscriptionBuyEdit_config_Cancelled',
  ),
});
